
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { feedService } from "@/services/feedService";
import { TrendingUp } from "lucide-react";
import { Link } from "@/lib/router-compat";
import T from "@/i18n/T";

const WhatsHappening = () => {
  const { data: trends, isLoading } = useQuery({
    queryKey: ['trending-topics'],
    queryFn: feedService.getTrendingTopics,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <TrendingUp className="h-5 w-5" />
          <T k="auto.what-s-happening-ee6c" />
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="space-y-1">
                <Skeleton className="h-4 w-2/3" />
                <Skeleton className="h-3 w-1/3" />
              </div>
            ))}
          </div>
        ) : (
          <ul className="space-y-4">
            {trends && trends.length > 0 ? (
              trends.map((trend) => (
                <li key={trend.topic}>
                  <Link to={`/search?q=${encodeURIComponent(trend.topic)}`} className="hover:underline">
                    <p className="font-semibold">{trend.topic}</p>
                    <p className="text-sm text-muted-foreground">{trend.count} {trend.count === 1 ? 'post' : 'posts'}</p>
                  </Link>
                </li>
              ))
            ) : (
              <p className="text-sm text-muted-foreground"><T k="auto.no-trending-topics-right-now-3638" /></p>
            )}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default WhatsHappening;
